<template>
  <div>
    <el-col :span="24">
      <el-menu
        default-active=""
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        @select="changeSelect"
      >
        <el-menu-item index="" id="rr" v-if="isRemoteRecordingEnabled">
          <span slot="title">{{ $t('lang.remoteRecordFile') }}</span>
        </el-menu-item>
       <!-- <el-menu-item index="rf" id="rf">
                              <i class="el-icon-menu"></i>
          <span slot="title">{{ $t('lang.recordedFile') }}</span>
        </el-menu-item>-->

        <el-menu-item index="mf" v-if="this.$store.state.isMarker">
          <span slot="title">{{ $t('lang.markerFile') }}</span>
        </el-menu-item>

        
      </el-menu>
    </el-col>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {},
  data() {
    return {};
  },
  computed: {
  ...mapState({
      isRemoteRecordingFeatureEnabled: (state) =>
        state.isRemoteRecordingFeatureEnabled,
    }),
    isRemoteRecordingEnabled() {
      return this.$store.state.isRemoteRecordingFeatureEnabled;
    },
  },
  created() {
    setTimeout(() => {
      const currentPath = this.$route.path;
      // const resultOne = window.location.href.includes('/rf')
      // console.log(resultOne, 'created', this.isRemoteRecordingEnabled)
      if (this.isRemoteRecordingEnabled) {
        if (currentPath === '/rf') {
          this.changeActiveClass('#rf', '#rr');
        } else {
          this.changeActiveClass('#rr', '#rf');
        }
      } else {
        if (currentPath === '/rr') {
          this.changeActiveClass('#rr', '#rf');
        } else {
          this.changeActiveClass('#rf', '#rr');
        }
      }
    }, 1000);
  },
  methods: {
    changeActiveClass(activeId, inActiveId) {
      // console.log(activeId, 'activeId->inActiveId', inActiveId)
      if (document.querySelector(activeId)) {
        document.querySelector(activeId).classList.add('is-active');
      }
      if (document.querySelector(inActiveId)) {
        document.querySelector(inActiveId).classList.remove('is-active');
      }
    },

    handleOpen(data) {
      // console.log(data)
    },
    handleClose(data) {
      // console.log(data)
    },
    changeSelect(data) {
      // window.sessionStorage.setItem('register', 1);
      // if (data === '') {
      //   window.localStorage.setItem('recordRemoteStorageInfo', '');
      // }
      const currentPath = this.$route.path;
      const toPath = '/' + data;
      if (currentPath == toPath) {
        return;
      }
      this.$router.push({ path: toPath });
      // const resultOne = window.location.href.includes('/rf')
      // console.log(resultOne, 'changeSelect', this.isRemoteRecordingEnabled)
      if (this.isRemoteRecordingEnabled) {
        if (toPath === '/rf') {
          this.changeActiveClass('#rf', '#rr');
        } else {
          this.changeActiveClass('#rr', '#rf');
        }
      } else {
        if (toPath === '/rr') {
          this.changeActiveClass('#rr', '#rf');
        } else {
          this.changeActiveClass('#rf', '#rr');
        }
      }
    },
  },
  watch: {
    isRemoteRecordingFeatureEnabled() {
      setTimeout(() => {
        const currentPath = this.$route.path;
        const resultOne = window.location.href.includes('/rf')
        // console.log(resultOne, 'watch', this.isRemoteRecordingEnabled)
        // alert(currentPath)
        if (this.isRemoteRecordingEnabled) {
          if (currentPath === '/rf' || resultOne === true) {
            this.changeActiveClass('#rf', '#rr');
          } else {
            this.changeActiveClass('#rr', '#rf');
          }
        } else {
          if (currentPath === '/rr') {
            this.changeActiveClass('#rr', '#rf');
          } else {
            this.changeActiveClass('#rf', '#rr');
          }
        }
      }, 2000);
    },
  },
};
</script>
<style lang="less" scoped>
.el-menu {
  border: none;
  background: #f6f7fa;
  padding-top: 5px;

  .is-active {
    color: #5dc045;
    font-weight: bold;
  }
}

.el-menu-item {
  font-size: 18px;
  padding-left: 32px !important;
}
// / ####### Dark Theme ####### /
.dark {
  .el-menu{
  background: #242628;
               .el-menu-item{
              color:#979da3;
              }
               .el-menu-item.is-active{
              color:#5dc045;
              }
              .el-menu-item:focus{
              background-color:transparent;
              }
               .el-menu-item:hover{
              background-color:transparent;
              }
        }
}
</style>
